/**
 * Core type definitions for the application
 */

export interface QuizConfig {
  seed: number;
  questionCount: number;
  chapter: string;
  book: string;
  questionType: 'true_false' | 'multiple_choice';
}

export interface QuizStats {
  totalAnswered: number;
  totalCorrect: number;
  totalIncorrect: number;
  accuracy: number;
  studyBankCount: number;
}

export interface QuizScore {
  correct: number;
  total: number;
}

export interface QuestionSelectionResult {
  questions: any[];
  totalAvailable: number;
  selectedCount: number;
}

// App-friendly types (used throughout the application)
export interface AppQuestion {
  id: string;
  question: string;
  type: 'true_false' | 'multiple_choice';
  correctAnswer: boolean | string;
  explanation: string;
  options: string[] | Record<string, string>;
}

export interface AppChapter {
  chapter_id: string;
  trueFalseQuestions: AppQuestion[];
  multipleChoiceQuestions: AppQuestion[];
}

export interface AppBook {
  book_id: string;
  chapters: { [chapter_id: string]: AppChapter };
  title: string;
}

export class Books {
  books: AppBook[];

  constructor(books: AppBook[]) {
    this.books = books;
  }

  getBookIdByTitle(title: string): string {
    const book = this.books.find(book => book.title === title);
    if (!book) {
      throw new Error(`Unknown book title: ${title}`);
    }
    return book.book_id;
  }

  getBookById(bookId: string): AppBook | null {
    const book = this.books.find(book => book.book_id === bookId);
    return book || null;
  }
}

// SM* types (used for data loading)
export interface SMPage {
    page_id: string;
    chapter_id: string;
    questions: any[];
}

export interface SMChapter {
    chapter_id: string;
    true_false_questions: SMPage[];
    multiple_choice_questions: SMPage[];
}

export interface SMBook {
    book_id: string;
    chapters: { [chapter_id: string]: SMChapter; };
}
